// Utils
import { registerElementType } from '../../elements/elementRegistry';
import elementConstructor from '../../elements/elementConstructor';

// Constants
import { ANNOTATION_TYPE, ANNOTATION_DISPLAY_NAME } from './annotationConstants';
import { ACCESS_BITS } from '../../permissions/permissionConstants';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: ANNOTATION_TYPE,
        content: {
            transparent: {
                enabled: true,
            },
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: ANNOTATION_TYPE,
        objectConstructorFn,
        displayName: ANNOTATION_DISPLAY_NAME,
        editPermission: ACCESS_BITS.FEEDBACK,
        savePermission: ACCESS_BITS.FEEDBACK,
        ...params,
    });
